import React from "react";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  Divider,
} from "@mui/material";

function BioThread() {
  const navigate = useNavigate();
  const location = useLocation();

  const currentPath = location.pathname;
  const initialMode = currentPath.includes("litmap") ? "litmap" : "discover";
  const [mode, setMode] = React.useState(initialMode);

  const handleSwitch = (event, newMode) => {
    if (newMode) {
      setMode(newMode);
      navigate(`/biothread/${newMode}`);
    }
  };

  return (
    <Box
      sx={{
        px: { xs: 2, md: 6 },
        py: 4,
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        gap: 4,
        minHeight: "77vh",
        // bgcolor: "background.default",
      }}
    >
      {/* LEFT SIDEBAR */}
      <Box
        sx={{
          flex: { xs: "1 1 auto", md: "0 0 340px" },
          position: { md: "sticky" },
          top: 24,
          alignSelf: "flex-start",
          borderRadius: 2,
          backdropFilter: "blur(14px)",
      
          p: 3,
          boxShadow: 1,
          zIndex: 10,
        }}
      >
        {/* Accent strip */}
        <Box
          sx={{
            position: "absolute",
            left: 0,
            top: 0,
            bottom: 0,
            width: 6,
            background: "linear-gradient(180deg, #1e3a8a, #3b82f6)",
            borderRadius: "0 4px 4px 0",
          }}
        />

        {/* Header */}
        <Typography
          variant="h4"
          fontWeight={800}
          sx={{
            mb: 2,
            background: "linear-gradient(90deg, #1e3a8a, #3b82f6)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            letterSpacing: 1,
          }}
        >
          BioThread
        </Typography>

        {/* Subtitle */}
        <Typography variant="body2" sx={{ color: "text.secondary", mb: 3 }}>
          AI-powered sequence intelligence suite
        </Typography>

        {/* Toggle Buttons */}
        <ToggleButtonGroup
          orientation="vertical"
          value={mode}
          exclusive
          onChange={handleSwitch}
          fullWidth
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
            "& .MuiToggleButton-root": {
              borderRadius: 2,
              justifyContent: "flex-start",
              px: 3,
              py: 1.6,
              textTransform: "none",
              fontWeight: 600,
              fontSize: "1rem",
              transition: "all 0.25s ease",
              border: "1px solid transparent",
              "&:hover": {
                transform: "translateX(4px)",
                borderColor: "primary.main",
                backgroundColor: "action.hover",
              },
              "&.Mui-selected": {
                background: "linear-gradient(90deg, #1e3a8a, #3b82f6)",
                color: "#fff",
                boxShadow: "0 4px 12px rgba(59, 130, 246, 0.4)",
                transform: "translateX(4px)",
              },
            },
          }}
        >
          <ToggleButton value="discover">Discover</ToggleButton>
          <ToggleButton value="litmap">RELIO</ToggleButton>
        </ToggleButtonGroup>

        {/* Description Box */}
        <Box sx={{ mt: 4 }}>
          <Typography variant="subtitle1" fontWeight={700} gutterBottom>
            {mode === "discover" ? "Discover" : "RELIO"}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {mode === "discover"
              ? "Enter a compound and instantly discover its strongest biologically supported outcomes based on current PubMed evidence."
              : "RLITerature-driven Molecular Association & Pathway mapping"}
          </Typography>
        </Box>
      </Box>

      {/* RIGHT CONTENT */}
      <Box sx={{ flex: 1, minHeight: "100%", width: "100%" }}>
        <Outlet />
      </Box>
    </Box>
  );
}

export default BioThread;
